class SearchDrawer extends Drawer {
  constructor() {
    super();
    this.resetButton = this.querySelector('.search-drawer__country-filter-reset-button');

    if (this.resetButton) {
      this.resetButton.addEventListener('click', this.resetFilter.bind(this));
    }
  }

  open(triggeredBy) {
    super.open(triggeredBy);

    setTimeout(() => {
      const searchInput = this.querySelector('#search__input');
      if (searchInput && typeof searchInput.focus === 'function') {
        searchInput.focus();
      }
    }, 250);
  }

  close() {
    super.close();
    // Clean up any search-specific state
    this.clearSearchInput();
  }

  resetFilter(event) {
    event.preventDefault();
    this.clearSearchInput();
  }

  clearSearchInput() {
    const searchInput = this.querySelector('#search__input');
    if (searchInput) {
      searchInput.value = '';
      const changeEvent = new Event('change', { bubbles: true });
      searchInput.dispatchEvent(changeEvent);
    }
  }
}

customElements.define('search-drawer', SearchDrawer);
